// Home
export const home = '/';

// Dashboard
export const dashboardSale = '/dashboard';
export const dashboardStock = '/dashboard-stock';
export const dashboardPrediction = '/dashboard-prediction';

// Catalog
export const catalog = 'catalog';
export const catalogProduct = `/${catalog}/product`;
export const catalogUploads = `catalog-uploads`;
export const catalogUploadsByUpload = `/${catalogUploads}/by-upload`;
export const catalogUploadsBySeason = `/${catalogUploads}/by-season`;
export const catalogAddCatalog = `/${catalogUploads}/add-catalog`;
export const catalogAddCatalogImagesPreview = `${catalogAddCatalog}/upload-images`;
export const catalogCorrelation = `/${catalog}/correlation`;
export const catalogGeneric = `/${catalog}/generic`;
export const catalogTarifs = `/${catalog}/tarifs`;
export const catalogDownload = `/${catalog}/download`;
export const catalogUpdateReferences = `/${catalog}/update-references`;

// Multimedia
export const multimedia = '/multimedia';
export const multimediaImages = `${multimedia}/images`;
export const multimediaVideos = `${multimedia}/videos`;
export const multimediaBanners = `${multimedia}/banners`;

// Clients
export const clientsPath = 'clients';
export const pointsOfSalePath = 'points-of-sale';
export const addClient = '/add-client';

// Client
export const client = '/client';
export const clResume = 'resume';
export const clPointsOfSale = 'points-of-sale';
export const clContacts = 'contacts';
export const clBrandsSold = 'brands';
export const clientResume = `${client}/${clResume}`;
export const clientContacts = `${client}/${clContacts}`;
export const clientPointsOfSale = `${client}/${clPointsOfSale}`;
export const clientBrandsSold = `${client}/${clBrandsSold}`;

// Account
export const account = '/account';
export const profile = 'profile';
export const company = 'company';
export const contacts = 'contacts';
export const commercialAgents = 'commercial-agents';
export const accountProfile = `${account}/${profile}`;
export const accountCompany = `${account}/${company}`;
export const accountContacts = `${account}/${contacts}`;
export const accountCommercial = `${account}/${commercialAgents}`;

// Import file
export const importPage = '/import';
export const importFile = `${importPage}/file`;
export const importHistory = `${importPage}/history`;

// Config
export const settings = '/settings';
const users = 'users';
const chronos = 'chronos';
const devices = 'devices';
const touchScreen = 'touch-screen';
const system = 'system';
const commercialProfile = 'commercial-profile';
const billing = 'billing';
const support = 'support';
const dataIntegration = 'data-integration';
const createUpdateMapping = 'mapping';
export const settingsUsers = `${settings}/${users}`;
export const settingsChronos = `${settings}/${chronos}`;
export const settingsDevices = `${settings}/${devices}`;
export const settingsTouchScreen = `${settings}/${touchScreen}`;
export const settingsSystemSettings = `${settings}/${system}`;
export const settingsCommercialProfile = `${settings}/${commercialProfile}`;
export const settingsBilling = `${settings}/${billing}`;
export const settingsSupport = `${settings}/${support}`;
export const settingsDataIntegration = `${settings}/${dataIntegration}`;
export const settingsCreateUpdateMapping = `${settingsDataIntegration}/${createUpdateMapping}`;

export const settingsDataIntegrationEditAPI = `${settingsDataIntegration}/edit-api-connection`;
export const settingsDataIntegrationGeneralConfigurationAPI = `${settingsDataIntegration}/general-api-configuration`;
export const settingsDataIntegrationMapFieldsConfigurationAPI = `${settingsDataIntegration}/map-fields-configuration`;
export const settingsDataIntegrationMaps = `${settingsDataIntegration}/maps`;
export const settingsDataIntegrationEditMap = `${settingsDataIntegration}/edit-map`;

// Authentication
export const authentication = '/authentication';
export const authenticationSignup = `${authentication}/signup`;

// Admin
export const adminHome = '/admin/home';
export const adminAPIConfiguration = '/admin/api-configuration';
export const adminMap = '/admin/map';
export const adminDataIntegration = '/admin/data-integration';

// Notifications
export const notifications = '/notifications';

// Wholesale Feed
export const wholesaleFeed = '/wholesale-feed';

// Sales
export const sales = '/sales';
export const salesMatching = `${sales}/matching`;
